import React from "react";
import { Row, Col } from "react-bootstrap";
import { BaseInput, BaseForm, BaseFieldSet, BaseSelect, CPF_MASK } from "react-epharma-components";

const Search: React.FC = (props) => {
  const id = React.createRef<BaseInput>();
  const author = React.createRef<BaseInput>();
  const initialDate = React.createRef<BaseInput>();
  const finalDate = React.createRef<BaseInput>();
  const notificationTypeValue = React.createRef<BaseSelect>();
  const targetTypeValue = React.createRef<BaseSelect>();

  return (
    <BaseForm refs={[id, author, initialDate, finalDate, notificationTypeValue, targetTypeValue]} {...props}>
      <BaseFieldSet legend="Filtros">
        <Row>
          <Col xs="4" sm="4" md="4" lg="4" xl="4">
            <BaseInput label="CPF" name="CPF" id="CPF" mask={CPF_MASK} ref={id} />
          </Col>
        </Row>
      </BaseFieldSet>
    </BaseForm>
  );
};
export default Search;
